import {
  FunctionComponent,
} from 'react';
import { Route } from 'react-router-dom';

import { AdminRouteName } from '../CONSTANTS';
import AllRepayments from './AllRepayment';
import DefaultRepayments from './DefaultRepayments';
import DashboardWrap from '../../components/DashboardWrap';
import UpcomingRepayments from './UpcomingRepayments';
import DueRepayments from './DueRepayments';
import PaidRepayments from './PaidRepayments';

import './repayment.scss';

const AdminRepayments: FunctionComponent = () => (
  <DashboardWrap>
    <div className="repayments-root-cover">
      <Route component={AllRepayments} path={AdminRouteName.repaymentsRoute} exact />
      <Route component={DueRepayments} path={AdminRouteName.dueRepaymentRoute} />
      <Route component={UpcomingRepayments} path={AdminRouteName.upcomingRepaymentRoute} />
      <Route component={DefaultRepayments} path={AdminRouteName.defaultRepaymentRoute} />
      <Route component={PaidRepayments} path={AdminRouteName.paidRepaymentRoute} />
    </div>
  </DashboardWrap>
);

export default AdminRepayments;
